// ported from the app repo (src/js/wisemetering/utils.js), which is where the
// WiseMetering global lives — this app has no such global.
const LOWERCASE = 'abcdefghijklmnopqrstuvwxyz';
const NUMBERS = '0123456789';
const SPECIAL_CHARS = '!\\#$%&()*+-=?@^_~';
const UPPERCASE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export default () => {
    const length = 16 + Math.floor(Math.random() * (32 - 16 + 1)); // Random length between 16-32
    const allChars = UPPERCASE + LOWERCASE + NUMBERS + SPECIAL_CHARS;

    const password = [
        UPPERCASE[Math.floor(Math.random() * UPPERCASE.length)],
        LOWERCASE[Math.floor(Math.random() * LOWERCASE.length)],
        NUMBERS[Math.floor(Math.random() * NUMBERS.length)],
        SPECIAL_CHARS[Math.floor(Math.random() * SPECIAL_CHARS.length)]
    ];

    for (let i = 4; i < length; i++) {
        password.push(allChars[Math.floor(Math.random() * allChars.length)]);
    }

    return password.sort(() => 0.5 - Math.random()).join('');
};
